import { createContext, useContext, useEffect, useState } from "react";
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
import { useLocation } from "react-router-dom";
import { useAppOverrides } from "contexts/AppOverridesContext";
import { generalRouteTitles } from "./routeTitles";


type AccessibilityContextType = {
    courseName: string;
    setCourseName: (courseName: string) => void;
    pageTitle: string;
    setPageTitle: (title: string) => void;
    setPathname: (pathname: string) => void;
}

const defaultData = {
    courseName: "",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
    setCourseName: (courseName) => {},
    pageTitle: "",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
    setPageTitle: (title) => {},
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
    setPathname: (pathname) => {},
}

export const AccessibilityContext = createContext<AccessibilityContextType>(defaultData);


export const AccessibilityProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {

    const {appName} = useAppOverrides();
    const [courseName, setCourseName] = useState("");
    const [pageTitle, setPageTitle] = useState("");
    const [pathname, setPathname] = useState("");



    useEffect(() => {
        const pathParts = pathname.split("/");
        // remove the first part (empty string)
        let segments = pathParts.slice(1);
        if (segments.length === 1) {
            const title = segments[0] === "" && appName
                ? appName
                : getPageTitle(segments, generalRouteTitles);
            // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
            setPageTitle(title ?? "");
        } else if (pageTitle && courseName) {
            document.title = `${pageTitle} - ${courseName}`;
        } else if (pageTitle) {
            document.title = pageTitle;
        } else {
            // slice the courseId from the segments
            segments = segments.slice(1);
            const newPageTitle = segments.length === 0 && appName
                ? appName
                : getPageTitle(segments, generalRouteTitles);
            if( newPageTitle ) {
                document.title = newPageTitle;
            }
        }



    }, [pathname, courseName, pageTitle, appName]);



    return (
        <AccessibilityContext.Provider value={{
            courseName,
            setCourseName,
            pageTitle,
            setPageTitle,
            setPathname
        }}>
            {children}
        </AccessibilityContext.Provider>
    )
}


export const useSetPageTitle = () => {

    const { setPageTitle } = useContext(AccessibilityContext);

    return setPageTitle;
}

export const useSetCourseName = () => {

    const { setCourseName } = useContext(AccessibilityContext);

    return setCourseName;

}



const getPageTitle = (segments, routesObj) => {
    if (segments.length < 1) {
        return "Code in Place";
    }
    // Remove the first segment (empty string)
    let currRoutsObject = routesObj;

    for(let i = 0; i < segments.length; i++) {
        const segment = segments[i];
        if (segment in routesObj) {
            if (typeof(routesObj[segment]) === 'string') {
                return routesObj[segment];
            } else if (typeof(routesObj[segment]) === 'object') {
                 
                // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
                currRoutsObject = routesObj[segment];
            } else {
                return;
            }
        }
    }
    return;
}